<template>
  <b-overlay :show="loading">
    <BatchesFilters
      :value="filters"
      :onChange="onChangeFiltersHistory"
      :clear="clearFiltersHistory"
      :is-history="true"
    />
    <div class="text-left mb-2 d-flex justify-content-start align-items-center">
      <b-button
        class="ml-4 badge-glow"
        variant="warning"
        size="sm"
        data-cy="download"
        v-on:click="onDownloadHistory"
      >
        <feather-icon
          icon="DownloadIcon"
          class="mr-3"
        />
        <span class="align-middle">Descargar</span>
      </b-button>
    </div>
    <BatchesHeader/>
    <div
      class="force-render"
      :key="forceRender"
    >
      <AuctionHistoryRow
        :key="auctionBatch.loteId"
        v-for="auctionBatch in filteredAuctionsBatchesHistory"
        :auctionBatch="auctionBatch"
        :select-batch="selectBatch"
        v-on:reload-list="handleReloadList"
        data-cy="file"
      />
    </div>
    <div class="row">
      <div class="col-3">
        <div class="mt-5">
          Mostrando <select
          v-model="rowspp"
          @change="fetchAuctionsHistory()"
        >
          <option
            value="10"
            selected="selected"
          >10
          </option>
          <option value="15">15</option>
          <option value="30">30</option>
          <option value="50">50</option>
        </select> registros por página.
        </div>
      </div>
      <div class="col-9">
        <AuctionsPagination
          :show="filteredAuctionsBatchesHistory.length"
          v-model="page"
        />
      </div>
    </div>
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import BatchesFilters from '@/febos/aduanas/batches/views/components/BatchesFilters';
import BatchesHeader from '@/febos/aduanas/batches/views/components/BatchesHeader';
import AuctionsPagination from '@/febos/aduanas/auctions/views/components/AuctionsPagination';
import AuctionHistoryRow from '@/febos/aduanas/auctions/views/components/AuctionHistoryRow';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import { selectBatchState } from '@/febos/aduanas/batches/store/actions';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';
import { fetchAuctionBatchesHistoryList } from '@/febos/aduanas/auctions/store/actions';
import { auctionsBatchesHistory, loading } from '@/febos/aduanas/auctions/store/getters';
import { auctionHistoryList } from '@/febos/servicios/api/aduanas/auctions.api';

export default {
  components: {
    BatchesHeader,
    AuctionHistoryRow,
    BatchesFilters,
    AuctionsPagination
  },
  data() {
    return {
      view: this.$route.name,
      filters: '',
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      page: Number.parseInt(this.$route.query.page || 1, 10),
      selectedBatch: {},
      searchParam: false,
      forceRender: Date.now() // TODO: the files watch is triggered but the component not re-render.
    };
  },
  watch: {
    async page(page) {
      updateSearchParams({ page });
      await this.fetchAuctionsHistory();
    }
  },
  computed: {
    ...mapGetters('auctions', {
      auctionsBatchesHistory: auctionsBatchesHistory.name,
      loading: loading.name
    }),
    filteredAuctionsBatchesHistory() {
      return this.auctionsBatchesHistory;
    }
  },
  methods: {
    ...mapActions('batches', {
      selectBatchState: selectBatchState.name
    }),
    ...mapActions('auctions', {
      fetchAuctionBatchesHistoryList: fetchAuctionBatchesHistoryList.name
    }),
    selectBatch(batch) {
      this.selectedBatch = batch;
      this.selectBatchState(batch.loteId);
    },
    clearFiltersHistory() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 1 });
      this.$router.go();
    },
    async onChangeFiltersHistory(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchAuctionsHistory();
        }
      }
    },
    getFilters() {
      if (this.$route.query?.filters) {
        if (this.$route.query.filters.includes('loteId')) { return this.$route.query.filters; }
      }
      return mergeFilters(this.filters, this.$route.query.filters);
    },
    fetchAuctionsHistory() {
      const auctionId = this.$route.params.id;
      this.fetchAuctionBatchesHistoryList({
        subastaId: auctionId,
        filters: this.getFilters(),
        page: this.page,
        items: this.rowspp
      });
    },
    async onDownloadHistory() {
      const auctionId = this.$route.params.id;
      this.$vs.notify({
        title: 'Solicitando',
        text: 'Descargando historial',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'primary',
        position: ALERT_POSITION
      });
      try {
        const { data } = await auctionHistoryList({
          subastaId: auctionId,
          filters: this.getFilters(),
          format: 'csv'
        });
        const link = `https://${data.urlHistorial}`;
        window.open(link, '_blank');
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Ocurrió un error al descargar los registros',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          position: ALERT_POSITION
        });
      }
    },
    handleReloadList() {
      this.fetchAuctionsHistory();
    }
  },
  created() {
    this.selectBatchState('');
  },
  mounted() {
    this.fetchAuctionsHistory();
  }
};
</script>
